import {
  type AppState,
  type LogoutOptions,
  type RedirectLoginOptions,
  useAuth0,
} from '@auth0/auth0-vue'
import useAuthStore from '../store'

export default function useAuth() {
  const auth0 = useAuth0()
  const authStore = useAuthStore()

  const login = async () => {
    await auth0.loginWithPopup()

    const token = auth0.idTokenClaims.value?.__raw

    if (!token) {
      return
    }

    authStore.setToken(token)

    const email = auth0.idTokenClaims.value?.email ?? ''
    const givenName = auth0.idTokenClaims.value?.given_name ?? ''
    const familyName = auth0.idTokenClaims.value?.family_name ?? ''
    const id = auth0.idTokenClaims.value?.preferred_username ?? ''

    authStore.setUser({
      email,
      firstname: givenName,
      lastname: familyName,
      id,
    })

    authStore.setStep('loggedIn')
  }

  const loginWithRedirect = async (
    options?: RedirectLoginOptions<AppState>
  ) => {
    await auth0.loginWithRedirect({
      // authorizationParams: {
      //   redirect_uri: window.location.origin,
      // },
      appState: {
        target: window.location.pathname + window.location.search,
      },
      ...options,
    })
  }

  const logout = async (options?: LogoutOptions) => {
    await auth0.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
      ...options,
    })
  }

  return {
    ...auth0,
    loginWithRedirect,
    login,
    logout,
  }
}
